import XLSX from 'xlsx';


export function exportToXLSXFile(feedbackReport, eventReport) {
    const feedbackSummarySheet = getSurveyReportSheet(feedbackReport.summary)
    const allFeedbacksSheet = getAllFeedbacksSheet(feedbackReport.allFeedbacks)
    const eventSheet = getEventReportSheet(eventReport)

    const new_workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(new_workbook, feedbackSummarySheet, "SurveyReport");
    XLSX.utils.book_append_sheet(new_workbook, allFeedbacksSheet, "All feedbacks");
    XLSX.utils.book_append_sheet(new_workbook, eventSheet, "EventReport");

    XLSX.writeFile(new_workbook, 'sba-report.xlsx');
}


function getSurveyReportSheet(feedbackSummary) {
    const numberAnswersData = [
        ['number', 'question', 'answer'],
        ...feedbackSummary.slice(0, 4).map(d => [d.number, d.question, d.answers]),
        []
    ]

    const textAnswers = feedbackSummary.slice(4).map(q => [
        [q.number, q.question],
        ...q.answers.map(a => [a.userId, a.user, a.answer]),
        []
    ]).flat()

    const worksheet = XLSX.utils.aoa_to_sheet(numberAnswersData);
    XLSX.utils.sheet_add_aoa(worksheet, textAnswers, {origin: 'A7'})

    return worksheet
}


function getAllFeedbacksSheet(allFeedbacks) {
    const data = allFeedbacks.map(feedback => {
        const feedbackQuestions = Object.entries(feedback)
            .filter(v => v[0].includes('question'))
            .map(v => [v[0], v[1].question, v[1].answer])

        feedbackQuestions.sort((v, v1) => v[0].localeCompare(v1[0]))

        return [
            ['user', feedback.user],
            ['time', feedback.time],
            ...feedbackQuestions,
            []
        ]
    }).flat()

    return XLSX.utils.aoa_to_sheet(data);
}


function getEventReportSheet(eventReport) {
    return XLSX.utils.aoa_to_sheet(Object.entries(eventReport))
}